import { IMenuItemType } from "router/routerType";
import { AndroidOutlined } from "@ant-design/icons";
import adminsScreen from "../screens/ModerationsScreen/moderationsScreen";

/** Moderation: Dashboard Page */
export const MODERATION_SCREEN: IMenuItemType = {
  id: "moderation",
  path: "/moderation",
  component: adminsScreen,
  title: "Moderation",
  icon: AndroidOutlined,
  permissions: [],
};
